import { XlsxViewer } from '@extend-ai/react-xlsx'

interface XlsxViewerPreviewProps {
  file: ArrayBuffer
  fileName?: string
  height?: string | number
  isDark?: boolean
}

export function XlsxViewerPreview({
  file,
  fileName,
  height = '100%',
  isDark = false,
}: XlsxViewerPreviewProps) {
  return <XlsxViewer file={file} fileName={fileName} height={height} isDark={isDark} readOnly />
}
